import { useEffect, useMemo, useRef } from 'react'
import {
  STATIC_QUICK_ACTIONS,
  buildQuickActionsFuseIndex,
  searchQuickActions,
} from '../local/quickActionsRegistry'

/**
 * Headless additive search provider for quick actions
 * (New Set / New Pack / New Class / New Question, …).
 *
 * The full action list lives in quickActionsRegistry. This provider just
 * exposes the fuzzy-search half — the empty-state list is enumerated
 * directly by the dropdown.
 *
 * Each emitted hit shape:
 *   { id, label, icon, action, keywords,
 *     objectID, __quickAction: true, __localOrigin: true }
 *
 * The UI is expected to discriminate via __quickAction and dispatch the
 * matching side-effect based on `action`.
 */
function QuickActionsSearchProvider({ query, options, onResults }) {
  const fuse = useMemo(() => buildQuickActionsFuseIndex(STATIC_QUICK_ACTIONS), [])

  const onResultsRef = useRef(onResults)
  onResultsRef.current = onResults

  useEffect(() => {
    if (!query) {
      onResultsRef.current({ hits: [] })
      return
    }
    const limit = options && options.hitsPerPage ? options.hitsPerPage : 6
    const hits = searchQuickActions(fuse, query, limit)
    onResultsRef.current({ hits })
    // eslint-disable-next-line no-console
    console.log('[local-search:quick-actions]', {
      query, limit, hitCount: hits.length, hits,
    })
  }, [query, fuse, options])

  return null
}

export default QuickActionsSearchProvider
